const addListeners = () => {
  const drawers = document.querySelectorAll("quick-buy-drawer");

  if (!drawers.length) {
    return;
  }

  drawers.forEach((drawer) => {
    // detect content change with observer
    const observer = new MutationObserver(() => {
      initializeSwatches(drawer);
    });

    observer.observe(drawer, { childList: true });
  });
};

addListeners();

initializeSwatches = (drawer) => {
  const swatches = drawer.querySelector("[data-pl-swatches-collection]");
  // check every 500ms if swatches have `data-pl-swatches-loaded` attribute
  const interval = setInterval(() => {
    if (swatches.getAttribute("data-pl-swatches-loaded") === "true") {
      clearInterval(interval);
      console.log("swatches loaded");
      addSwatchLabel(drawer, swatches);
    }
  }, 500);
};

addSwatchLabel = (drawer, swatches) => {
  const activeSwatch = swatches
    .querySelector(".pl-swatches-collection__swatch-wrapper--active")
    .parentElement.getAttribute("title");

  const label = document.createElement("div");
  label.classList.add("pl-swatches__label");
  label.textContent = `COLOUR: ${activeSwatch}`;

  swatches
    .querySelector(":first-child")
    .insertAdjacentElement("beforebegin", label);

  // If dynamic replace is needed:

  // const links = swatches.querySelectorAll("a");
  // links.forEach((link) => {
  // link.addEventListener("click", (event) => {
  //   event.preventDefault();
  //   console.log(link.getAttribute("href"));

  //   replaceDrawerContent(drawer, link.getAttribute("href"));
  // });
  // });
};

replaceDrawerContent = (drawer, url) => {
  fetch(`${url}?view=quick-buy-drawer`)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, "text/html");
      const newDrawer = newDocument.querySelector("[data-content");
      const drawerContent = drawer.querySelector("[data-content]");
      if (!newDrawer || !drawerContent) {
        console.error("Drawer content not found");
        return;
      }
      drawerContent.innerHTML = newDrawer.innerHTML;
      initializeSwatches(drawer);
    });
};